import { render, staticRenderFns } from "./ClientePerfil.vue?vue&type=template&id=4d77743e&scoped=true"
import script from "./ClientePerfil.vue?vue&type=script&lang=js"
export * from "./ClientePerfil.vue?vue&type=script&lang=js"
import style0 from "./ClientePerfil.vue?vue&type=style&index=0&id=4d77743e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d77743e",
  null
  
)

export default component.exports